import { Skeleton } from '@lastbrand/web-ui/skeleton'
import { css } from '@lastbrand/web-ui-styled-system/css'

import type { PurchaseTypeSelectorShimmerProps } from './purchase-type-selector.types'

// Shimmer placeholder shown while the active-inventory API resolves. Mirrors legacy `.shimmerWrapper`
// (same margin/gap as the real selector container).
const shimmerWrapperCss = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'space-16',
  marginBlock: 'space-24',
})

// Placeholder heights approximating the two selector cards (expanded subscribe + collapsed one-time).
// No DS spacing token maps to these exact loader dimensions, so they stay as raw px (parity with legacy).
const SUBSCRIBE_CARD_HEIGHT = '124px'
const ONE_TIME_CARD_HEIGHT = '42px'

export const PurchaseTypeSelectorShimmerDS = ({ showShimmer, children }: PurchaseTypeSelectorShimmerProps) => {
  if (!showShimmer) return children

  return (
    <div className={shimmerWrapperCss}>
      <Skeleton css={{ width: 'full', height: SUBSCRIBE_CARD_HEIGHT }} />
      <Skeleton css={{ width: 'full', height: ONE_TIME_CARD_HEIGHT }} />
    </div>
  )
}
